// survey.repo — Survei Kepuasan (tersimpan di tiket). Sumber CSAT/response_rate KPI.
import { supabase } from '@core/supabase';
import { fetchAllPaged } from '@core/paging';

export interface SurveyRow {
  no: string; token: string; custNama: string; custWa: string; unit: string; outlet: string; teknisi: string | null;
  tglAmbil: string | null; hasil: string | null; surveyDone: boolean; rating: number | null; surveyKet: string | null;
}
interface Embed { nama?: string; wa?: string }
interface Raw {
  no: string; token: string | null; unit: string | null; outlet: string; teknisi: string | null; tgl_ambil_iso: string | null; hasil: string | null;
  survey_done: boolean | null; rating: number | null; survey_ket: string | null; customers: Embed | Embed[] | null;
}
const nm = (c: Embed | Embed[] | null, k: 'nama' | 'wa'): string => ((Array.isArray(c) ? c[0]?.[k] : c?.[k]) ?? '');

const map = (r: Raw): SurveyRow => ({
  no: r.no, token: r.token ?? '', custNama: nm(r.customers, 'nama') || '—', custWa: nm(r.customers, 'wa'), unit: r.unit ?? '', outlet: r.outlet,
  teknisi: r.teknisi, tglAmbil: r.tgl_ambil_iso, hasil: r.hasil, surveyDone: r.survey_done ?? false, rating: r.rating, surveyKet: r.survey_ket,
});
const SEL = 'no,token,unit,outlet,teknisi,tgl_ambil_iso,hasil,survey_done,rating,survey_ket,customers(nama,wa)';

/** Tiket yang layak disurvei (sudah diambil) + status survei — utk laporan. RLS scope cabang. */
export async function listSurveyable(): Promise<SurveyRow[]> {
  const data = await fetchAllPaged<Raw>((dari, sampai) => supabase().from('tickets').select(SEL)
    .eq('status', 'Sudah Diambil').eq('archived', false)
    .order('tgl_ambil_iso', { ascending: false }).range(dari, sampai));
  return (data as unknown as Raw[]).map(map);
}

/** Cari tiket by token (utk submit survei publik/simulasi). */
export async function findByToken(token: string): Promise<SurveyRow | null> {
  const { data, error } = await supabase().from('tickets').select(SEL).eq('token', token).limit(1);
  if (error) throw new Error(error.message);
  const r = (data as unknown as Raw[] | null)?.[0];
  return r ? map(r) : null;
}

export async function submit(no: string, rating: number, ket: string): Promise<void> {
  const { error } = await supabase().from('tickets')
    .update({ survey_done: true, rating, survey_ket: ket || null, survey_at: new Date().toISOString() }).eq('no', no);
  if (error) throw new Error(error.message);
}
